module.exports = __webpack_public_path__ + "static/Forbes-ad6455eb0dfd4be6402cb9f1f5d5379f.png";